// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalAlignMiddleOutlinedSvg from "@fishx/icons-svg/es/asn/VerticalAlignMiddleOutlined";
import FishxIcon from '../components/FishxIcon';

var VerticalAlignMiddleOutlined = function VerticalAlignMiddleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignMiddleOutlinedSvg
  }));
};

VerticalAlignMiddleOutlined.displayName = 'VerticalAlignMiddleOutlined';
export default React.forwardRef(VerticalAlignMiddleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VerticalAlignMiddleOutlined.js
// module id = 4366
// module chunks = 0